<div (contextmenu)="contextClick($event)">

    <div *ngIf="scheduleAbsences.length > 0" class="main-box main-box--scheduled-absence layout-mb-4">
        <ng-container *ngFor="let scheduleAbsence of scheduleAbsences; let firstScheduleAbsence = first">
            <div *ngIf="!firstScheduleAbsence" class="main-box__divider"></div>
            <ng-content *ngTemplateOutlet="absenceTemplate; context: { absence: scheduleAbsence}">
            </ng-content>
        </ng-container>
    </div>

    <div *ngIf="calendarAbsences.length > 0" class="main-box main-box--calendar-event">
        <ng-container *ngFor="let calendarAbsence of calendarAbsences; let first = first">
            <div *ngIf="!first" class="main-box__divider"></div>
            <ng-content *ngTemplateOutlet="absenceTemplate; context: { absence:calendarAbsence }">
            </ng-content>
        </ng-container>
    </div>
    <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
</div>


<ng-template #absenceTemplate let-absence="absence">
    <div class="main-box__absence-box flexContent flexColumn justify-center align-center gap-4 text-align-center">

        <div class="text-align-center font-weight-bolder">
            <span *ngIf="absence.typeTitle">{{absence.typeTitle}}: </span>
            {{ absence.title}}
        </div>

        <div class="text-align-center">
            ({{ absence.objectName }})
        </div>

        <div>
            {{ absence.dateFrom | date: 'dd.MM.yyyy'}}
            <span *ngIf="absence.dateTo"> - {{ absence.dateTo | date: 'dd.MM.yyyy'}}</span>
        </div>
    </div>
</ng-template>




<mat-menu #menu="matMenu" xPosition="before">

    <ng-container *hasPermission="[PERM.ACCESS.TODRIVERS, PERM.EDIT, PERM.MODULE]">
        <button *ngIf="driver" type="button" mat-menu-item
            (click)="onAddAbsenceClick(businessObjectType.DRIVER, driver.driverId)">
            <mat-icon>person_alert</mat-icon>
            <span>Dodaj niedostępność dla kierowcy</span>
        </button>
    </ng-container>

    <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
        <button *ngIf="driver" type="button" mat-menu-item
            (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.vehicleId)">
            <mat-icon>directions_bus</mat-icon>
            <span>Dodaj niedostępność dla pojazdu</span>
        </button>
    </ng-container>

    <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
        <button *ngIf="driver && driver.trailerId" type="button" mat-menu-item
            (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.trailerId)">
            <mat-icon>rv_hookup</mat-icon>
            <span>Dodaj niedostępność dla przyczepy</span>
        </button>
    </ng-container>

</mat-menu>